import { configureStore } from '@reduxjs/toolkit'
import filterReducer from '../features/filter/filterSlice'
import sortReducer from '../features/table/sortSlice'
import paginationReducer from '../features/table/pagintaionSlice'
import currencyReducer from '../features/currency/currencySlice'
import partsInBasketReducer from '../features/table/partsInBasketSlice'
import notepadPartsReducer from '../features/table/notepadSlice'
import comparePartsReducer from '../features/table/compareSlice'

export default configureStore({
    reducer: {
        filter: filterReducer,
        sort: sortReducer,
        pagination: paginationReducer,
        currency: currencyReducer,
        partsInBasket: partsInBasketReducer,
        notepadParts: notepadPartsReducer,
        compareParts: comparePartsReducer
    }
})
